import { action } from 'typesafe-actions';
import { FETCH_GAMES_SUCCESS, FETCH_CHEATS_SUCCESS, FETCH_UPDATED_SUCCESS, FETCH_FAILED, } from './constants';
export const fetchFailed = () => action(FETCH_FAILED);
export const fetchGamesSuccess = (options) => action(FETCH_GAMES_SUCCESS, Object.assign({}, options));
export const fetchUpdatedSuccess = (games) => action(FETCH_UPDATED_SUCCESS, { games });
export const fetchCheatsSuccess = (options) => action(FETCH_CHEATS_SUCCESS, Object.assign({}, options));
